import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-12c942de"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "home" }
const _hoisted_2 = { class: "df flex-col" }
const _hoisted_3 = { class: "min-height-100px" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "pt30px" }, [
  /*#__PURE__*/_createTextVNode(" 同时掷三枚硬币，"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode(" 记"),
  /*#__PURE__*/_createElementVNode("mark", null, "背面朝上"),
  /*#__PURE__*/_createTextVNode("的硬币个数，"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode(" 共掷六次，"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode(" 填入下表。"),
  /*#__PURE__*/_createElementVNode("br")
], -1))
const _hoisted_5 = /*#__PURE__*/_createTextVNode(" 成卦 ")
const _hoisted_6 = /*#__PURE__*/_createTextVNode(" 重置 ")
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createTextVNode("请填写每掷"),
  /*#__PURE__*/_createElementVNode("mark", null, "背面朝上"),
  /*#__PURE__*/_createTextVNode("的硬币个数:")
], -1))
const _hoisted_8 = {
  class: "cursor-default",
  title: "同时掷三个铜钱, 记录背面朝上的铜钱个数, 为一爻"
}
const _hoisted_9 = /*#__PURE__*/_createTextVNode("0")
const _hoisted_10 = /*#__PURE__*/_createTextVNode("1")
const _hoisted_11 = /*#__PURE__*/_createTextVNode("2")
const _hoisted_12 = /*#__PURE__*/_createTextVNode("3")
const _hoisted_13 = { style: {"margin-left":"10px"} }
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "pt30px" }, "或者你懒得掷硬币也可以使用\"随机成卦\"(笑)", -1))
const _hoisted_16 = /*#__PURE__*/_createTextVNode(" 随机成卦 ")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_GuaView = _resolveComponent("GuaView")!
  const _component_NButton = _resolveComponent("NButton")!
  const _component_NButtonGroup = _resolveComponent("NButtonGroup")!
  const _component_NRadio = _resolveComponent("NRadio")!
  const _component_NRadioGroup = _resolveComponent("NRadioGroup")!
  const _component_NSpace = _resolveComponent("NSpace")!
  const _component_NCard = _resolveComponent("NCard")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_NCard, { title: "其实我觉得不用铜钱，用硬币也行" }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createVNode(_component_GuaView, { ref: "guaViewRef" }, null, 512)
          ]),
          _createElementVNode("div", null, [
            _createVNode(_component_NSpace, {
              size: "large",
              vertical: ""
            }, {
              default: _withCtx(() => [
                _hoisted_4,
                _createVNode(_component_NButtonGroup, { size: "small" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_NButton, {
                      secondary: "",
                      round: "",
                      type: "primary",
                      onClick: _ctx.handleGenerate
                    }, {
                      default: _withCtx(() => [
                        _hoisted_5
                      ]),
                      _: 1
                    }, 8, ["onClick"]),
                    _createVNode(_component_NButton, {
                      secondary: "",
                      round: "",
                      onClick: _ctx.handleReset
                    }, {
                      default: _withCtx(() => [
                        _hoisted_6
                      ]),
                      _: 1
                    }, 8, ["onClick"])
                  ]),
                  _: 1
                }),
                _hoisted_7,
                _createElementVNode("div", null, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.curYaoList, (yao, idx) => {
                    return (_openBlock(), _createElementBlock(_Fragment, { key: idx }, [
                      _createElementVNode("span", _hoisted_8, " [第" + _toDisplayString(_ctx.nzhcn.encodeS(idx + 1)) + "掷] " + _toDisplayString(_ctx.yaoLabelList[idx]) + " : ", 1),
                      _createVNode(_component_NRadioGroup, {
                        value: _ctx.curYaoList[idx],
                        "onUpdate:value": ($event: any) => ((_ctx.curYaoList[idx]) = $event)
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_NRadio, { value: "0" }, {
                            default: _withCtx(() => [
                              _hoisted_9
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_NRadio, { value: "1" }, {
                            default: _withCtx(() => [
                              _hoisted_10
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_NRadio, { value: "2" }, {
                            default: _withCtx(() => [
                              _hoisted_11
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_NRadio, { value: "3" }, {
                            default: _withCtx(() => [
                              _hoisted_12
                            ]),
                            _: 1
                          })
                        ]),
                        _: 2
                      }, 1032, ["value", "onUpdate:value"]),
                      _createElementVNode("span", _hoisted_13, " [ " + _toDisplayString(_ctx.curOriginYaoLabelList[idx]) + " ] ", 1),
                      _hoisted_14
                    ], 64))
                  }), 128))
                ]),
                _hoisted_15,
                _createVNode(_component_NButton, {
                  type: "primary",
                  size: "small",
                  round: "",
                  tertiary: "",
                  onClick: _ctx.handleEasyGenerate
                }, {
                  default: _withCtx(() => [
                    _hoisted_16
                  ]),
                  _: 1
                }, 8, ["onClick"])
              ]),
              _: 1
            })
          ])
        ])
      ]),
      _: 1
    })
  ]))
}